import axiosInstance from '@/api/axios'

// 获取订单列表
export function queryOrderDetailListApi(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/order/orderList/queryOrderDetailList',
        method: 'post',
        data: parameter,
    })
}

// 取消订单
export function deleteOrderByOrderNoApi(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/order/orderList/deleteOrderByOrderNo',
        method: 'post',
        data: parameter,
    })
}
// 去认证、去签名、去支付
export function toOperateApi(parameter: any): Promise<any> {
    return axiosInstance({
        url: '/order/orderList/toOperate',
        method: 'post',
        data: parameter,
    })
}
// // 去支付
// export function toPayApi(parameter: any): Promise<any> {
//     return axiosInstance({
//         url: '/order/orderList/toPay',
//         method: 'post',
//         data: parameter,
//     })
// }
